import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ConsentsService } from '../../services/consents.service';
import { HttpService } from '../../services/http.service';
import { CognitoServiceService } from '../../services/cognito-service.service';
import { DynamicItem } from 'src/app/models/dynamicItem';
import { PopupConsentPinComponent } from '../popups/popup-consent-pin/popup-consent-pin.component';
import { CommonService } from 'src/app/services/common/common.service';
import { AppConstants } from 'src/app/models/appConstants';

@Component({
  selector: 'app-consent-confirmation',
  templateUrl: './consent-confirmation.component.html',
  styleUrls: ['./consent-confirmation.component.scss']
})
export class ConsentConfirmationComponent implements OnInit {
  consentData: any = {};
  eventID: any;
  data: any;
  consentType: string;
  someAccountsAreNotRevoked = false;
  popupData: any;
  showPopupFlag = false;
  breadcrumb: { "label": string; "link": any[]; }[] = [];

  statusRevoked = "REVOKED";
  statusPaused = "PAUSED";
  statusActive = "ACTIVE";
  isActiveConsentRecord = false;

  actionObject: any;

  constructor(
    private consentService: ConsentsService,
    private cognito: CognitoServiceService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpService,
    private commonService: CommonService,
    private appConstants: AppConstants
  ) {
    this.consentType = "consentRequests";
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.eventID = params.id;
      this.consentType = params.consentType;

      if (this.consentType == "activeConsentRecords") {
        this.isActiveConsentRecord = true;
      }

      this.getConsents(params);
      this.setBreadcrumb();
    });
  }
  getConsents(paramOption) {
    let option = {
      type: 'get',
      url: 'consentHandle',
      includeUserSession: true,
      pathVariables: [this.eventID],
      isDeveloper: true
    }
    this.http.makeHttpRequest(option).subscribe(res => {
      if (res != undefined) {
        this.data = res['info'];
        if (!this.isActiveConsentRecord) {
          
          this.setBankList();
        } else{
          this.consentData["activeConsentBanksList"]=res['consents']?res['consents']:[];
        }
        this.setConsentData(this.data);
        this.getUpdatedStatus();
      }
    });
  }

  setBankList(){
    if(this.consentService.getData()){
      
      this.consentService.getData().bankAccounts.forEach(element => {
        element['accessAllowed'] = true;
      });
      this.consentData["banksList"] = this.consentService.getData().bankAccounts;
    }
    // else{
    //   this.consentData["banksList"] = this.consentService.getData().bankAccounts;
    // }
  }
  setConsentData(data) {
    if (data) {
     //Account-types==>saving, credit cards, mutual funds
      this.consentData["accounts"] = data.ConsentDetail.consentTypes//data.Account.accountTypes.split(/\s*,\s*/);
      //this.consentData["accounts"].length = this.consentData["accounts"].length - 1 ? this.consentData["accounts"].length - 1 : 1;
      //this.consentData["creditCards"] = this.consentData["accounts"].indexOf("Credit Cards") == -1 ? false : true;
      //this.consentData["mutualFunds"] = this.consentData["accounts"].indexOf("Mutual Funds") == -1 ? false : true;
      //this.consentData["insurances"] = this.consentData["accounts"].indexOf("Insurances") == -1 ? false : true;
      this.consentData["purpose"] = data.ConsentDetail.Purpose.text;
      
     this.consentData["fiuName"] = data.FIU && data.FIU.id ? data.FIU.id : "Insta Loans";

      let dateTimeRange = data.ConsentDetail.consentStart;//data["Data-Items"][0].DateTimeRange;
      this.consentData["startTime"] = data.ConsentDetail.consentStart;
      this.consentData["expireTime"] = data.ConsentDetail.consentExpiry;

      if (data["Data-Items"]) {
        this.consentData["frequency"] = data["Data-Items"][0].Frequency.unit;
        // if (data["Data-Items"][0].Frequency.unit == "MONTHLY") {
        //   this.consentData["toDate"].setMonth(this.consentData["toDate"].getMonth() + 1);
        // }
      }
      this.appConstants.consentData = this.consentData;
    }
  }

  consentConfirm(pin){
    this.consentData["banksList"].forEach(element => {
      delete element.consentArtefacts;
    });
    let options = {
      type: 'post',
      url: 'consentconfirm',
      isDeveloper: true,
      includeUserSession: true,
      data: {
        "refEventId": this.eventID,
        "HexPIN": pin+"",
        "accounts": this.consentData["banksList"]
      }
    }
    //Filter accounts based on the checked box
    options.data.accounts = this.filterSelectedAccounts();

    this.http.makeHttpRequest(options).subscribe(res => {
      if (res["errorMessage"] == 'ConsentPinMisMatch') {
        this.showGlobalPopup("Consent Pin Mismatch", "ConsentPin Error");
        return;
      } else {
        this.closePopup();
      }

      if(res['message']=='IN_OPERATION'){
        this.showGlobalPopup("Consent approved Successfully");
        this.route.navigate(['/dashboard']);
      }else if((res['message']=='APPROVED')&&(res['accounts'].length==0)){
        this.showGlobalPopup("Consent Declined Successfully");
        this.route.navigate(['/dashboard']);
      }else{
        this.showGlobalPopup("Pin mismatch or some error occured");
      }
      
    })
  }

  filterSelectedAccounts() {
    let selectedList = this.consentData["banksList"].filter(res => {
      return res.accessAllowed == true;
    });
    return selectedList;
  }

  declineConsent(pin) {
    this.consentData["banksList"].forEach(element => {
      element.accessAllowed = false;
    });
    this.consentConfirm(pin);
  }
  

  /**
   * @param event 
   * This will be triggered on consent update event emitter triggered or click
   * this will intiates the consent update by asking for pin
   * Actual update method will be triggered by popup on confirm
   * 
   * Following methods are for same, initiateConsentUpdate, initiateConsentRevoke, initiateConsnetAction, revokeAllConsents
   */
  initiateConsentUpdate(event) {
    this.actionObject = {
      consents : [event.consentId],
      status: event.status,
      accounts:event.accounts
    }
    this.showpopup();
  }

  initiateConsentRevoke(consentIds) {
    this.actionObject = {
      consents : consentIds,
      status: this.statusRevoked
    }
    this.showpopup();
  }

  initiateConsnetAction(type) {
    if(type == 'Confirm') {
      if(this.filterSelectedAccounts().length <= 0) {
        this.showGlobalPopup("Please select atleast One Account", "Consent Confirmation");
        return;
      }
    }
    this.actionObject = {
      status: type
    }
    this.showpopup();
  }

  revokeAllConsents() {
    let consents = this.consentData['activeConsentBanksList'];
    var toBeRevoked = consents.filter(consent => {
      return consent.status != this.statusRevoked;
    });
    var consentIds = toBeRevoked.map(consent => {
      return consent.consentArtefactId;
    });
    this.actionObject = {
      consents : consentIds,
      consentAccountId : consentIds[0],
      status: this.statusRevoked
    }
    this.showpopup();
  }


  /**
   * Invokes Consent Update API
   * @param pin ConsentPin
   */
  consentRevoke(pin) {
    this.actionObject.consentPin = pin
    this.actionObject.consentAccountId=this.actionObject.consents[0];
   
    this.consentService.consentUpdate(this.actionObject, (res) => {
      if (res["errorMessage"] == 'ConsentPinMisMatch') {
        this.showGlobalPopup("Invalid Consent Pin");
        return;
      } else {
        this.closePopup();
      }
      
      let consents = this.consentData['activeConsentBanksList'];
      for(var i=0, iLen = consents.length - 1; i <= iLen; i++) {
        let consent = consents[i];
        if(this.actionObject.consents.includes(consent.consentArtefactId)) {
          consent.status = this.actionObject.status;
          this.getUpdatedStatus();     
        }
      }
    });
  }

  /**
   * Invokes Consent Update API
   * @param pin ConsentPin
   */
  consentUpdate(pin) {
    this.actionObject.consentPin = pin
    this.consentService.consentUpdate(this.actionObject, (res) => {
      if (res["errorMessage"] == 'ConsentPinMisMatch') {
        this.showGlobalPopup("Invalid Consent Pin");
        return;
      } else {
        this.closePopup();
      }

      let consents = this.consentData['activeConsentBanksList'];
      for(var i=0, iLen = consents.length - 1; i <= iLen; i++) {
        let consent = consents[i];
        if(this.actionObject.consents.includes(consent.consentArtefactId)) {
          consent.status = this.actionObject.status; //Here at a time we can update single consent so breaking this loop
          break;
        }
      }
    });
  }


  /**
   * This method will take of consent action popups
   * Before calling this method we are updating 
   * actionObject with status and consents
   * 
   * Popup content and callbacks will be assigned based on status
   * On successfull confirm from popup binded events will be triggered
   */
  showpopup() {
    let eventType = this.actionObject.status;
    let popuptext = this.consentService.getPopupContent(eventType);
    
    switch(eventType) {
      case "Confirm":
        popuptext.successCallback = this.consentConfirm.bind(this);
        break;
      case "Decline":
        popuptext.successCallback = this.declineConsent.bind(this);
        break;
      case this.statusRevoked:
        popuptext.successCallback = this.consentRevoke.bind(this);
        break;
      case this.statusPaused:
      case this.statusActive:
        popuptext.successCallback = this.consentUpdate.bind(this);
        break;
    }
    popuptext.cancelCallback = this.closePopup.bind(this);

    this.popupData = new DynamicItem(PopupConsentPinComponent, popuptext);
    this.showPopupFlag = true;
  }

  /**
   * To hide Popup, we are changing ngIf to false.
   */
  closePopup() {
    this.showPopupFlag = false;
  }

  getUpdatedStatus() {
    this.someAccountsAreNotRevoked = this.consentData['activeConsentBanksList'].some((consent) => {
      return consent.status != this.statusRevoked ;
    });
  }

  setBreadcrumb() {
    this.breadcrumb = [];
    if(!this.isActiveConsentRecord){
      this.breadcrumb.push(
        { "label": "Consent Confirmation", "link": ["http://google.com"] }
      )
    }
    else{
        this.breadcrumb.push(
          { "label": "Consent Details", "link": ["http://google.com"] }
        )
    }
  }

  /**
   * To build and show global message popup
   * @param body popup body message
   * @param heading popup heading message
   */
  showGlobalPopup(body: string, heading?: string) {
    let popuptext = {
      heading: heading || "OnemoneyAA",
      body: body
    }

    this.commonService.showGlobalMessage(popuptext);
  }


}

